function AnalyticsConfig (sbAnalyticsProvider) {
  var initData = window.document.querySelector('#init-data') && JSON.parse(window.document.querySelector('#init-data').getAttribute('value'));

  var defaults = {
    segmentIO: {
      options: {
        flushAt: 10,
        flushAfter: 5000
      },
      writeKey: initData.segmentIOKey
    }
  };

  sbAnalyticsProvider.configGetter = function () {
    return defaults;
  };
}

AnalyticsConfig.$inject = ['sbAnalyticsProvider'];

module.exports = AnalyticsConfig;


// WEBPACK FOOTER //
// ./src/common/analytics/AnalyticsConfig.js